module.exports = __webpack_public_path__ + "static/media/resumepic.12e07398.png";